import React, { useEffect } from "react";
import * as _ from "lodash";
import * as Moment from "moment";
import "./index.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { editSession } from "../../store/session/thunkAction";
import { SessionStatus } from "../../constant/enums";
import Table from "../../components/core/table";

const VisitorPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const chatId = _.get(params, "id");

  const requesterManage = useSelector((state) => state.requesterManage);
  const staffManage = useSelector((state) => state.staffManage);

  const staff = _.get(staffManage, "staff", {});
  const requesterOnline = _.get(requesterManage, "requesterOnline");

  const timeAgo = (timestamp) => {
    const now = Moment();
    const time = Moment(timestamp);

    if (time.isAfter(now)) {
      return time.from(now);
    }
    return time.fromNow();
  };

  const onStartChat = async (sessionId) => {
    const staffId = _.get(staff, "_id");
    try {
      await dispatch(
        editSession({
          id: sessionId,
          data: {
            staffId,
            status: SessionStatus.PENDING,
          },
        })
      ).unwrap();
      navigate(`/chat/${chatId}/message/session-id/${sessionId}`);
    } catch (error) {}
  };

  const configTable = {
    header: [
      {
        key: "no",
        label: "NO.",
        className: "text-center small",
        render: (row, rowIndex) => rowIndex + 1,
      },
      {
        key: "domain",
        label: t("agent.visitor.current_page_url"),
        className: "small text-center",
        render: (row) => {
          const domain = _.get(row, "domain");
          let currentUrl = "";
          const attributes = _.get(row, "attributes", []);
          const visitorPath = _.get(
            _.find(attributes, { key: "visitorPath" }),
            "value",
            "[]"
          );

          try {
            const data = JSON.parse(visitorPath);
            const lastPath = _.last(data);
            currentUrl = _.get(lastPath, "url", "");
          } catch (error) {}

          return currentUrl || domain;
        },
      },
      {
        key: "duration",
        label: t("agent.visitor.duration"),
        className: "small text-center",
        render: (row) => {
          const timeOnline = _.get(
            _.find(row.attributes, { key: "timeOnline" }),
            "value",
            null
          );

          return timeOnline ? timeAgo(timeOnline) : "now";
        },
      },
      {
        key: "manage",
        label: t("agent.visitor.manage"),
        className: "text-center small",
        render: (row) => {
          const session = _.get(row, "session");
          const sessionId = _.get(session, "_id");
          const status = _.get(session, "status");

          return (
            <div>
              {status === SessionStatus.WAITING && (
                <button
                  className="text-nowrap btn btn-success-light btn-sm"
                  // onClick={() => onStartChat(sessionId)}
                >
                  <img
                    src="/img/chat/icon/chat.svg"
                    style={{
                      paddingRight: "5px",
                    }}
                    alt=""
                  />
                  {t("agent.visitor.start_chat")}
                </button>
              )}
              {status === SessionStatus.NEW && (
                <button
                  className="text-nowrap btn btn-success-light btn-sm"
                  onClick={() => onStartChat(sessionId)}
                >
                  <img
                    src="/img/chat/icon/chat.svg"
                    style={{
                      paddingRight: "5px",
                    }}
                    alt=""
                  />
                  {t("agent.chat.start_chat_with_visitor")}
                </button>
              )}
              {status === SessionStatus.CLOSED && (
                <button
                  className="text-nowrap btn btn-gray-light btn-sm"
                  onClick={() => {
                    navigate(`/chat/${chatId}/message/session-id/${sessionId}`);
                  }}
                >
                  {t("session.session_status.closed")}
                </button>
              )}
              {status === SessionStatus.SERVED && (
                <button
                  className="text-nowrap btn btn-info-light btn-sm"
                  onClick={() => {
                    navigate(`/chat/${chatId}/message/session-id/${sessionId}`);
                  }}
                >
                  {t("session.session_status.served")}
                </button>
              )}
              {status === SessionStatus.PENDING && (
                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => {
                    navigate(`/chat/${chatId}/message/session-id/${sessionId}`);
                  }}
                >
                  {t("session.session_status.pending")}
                </button>
              )}
            </div>
          );
        },
      },
    ],
    collection: requesterOnline,
  };

  return (
    <div className="chat-content-box h-100">
      <div className="row g-0 h-100" style={{ marginLeft: "10px" }}>
        <div>
          <div className="mb-4">{t("agent.visitor.desc")}</div>
          <div className="table-responsive table-box">
            <Table config={configTable} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisitorPage;
